<template>
  <v-row>
    <v-col>
      <v-table class="mt-1 table-striped">
        <tbody class="font-size-10-rem">
          <tr>
            <td class="text-left w-75">
              思う
            </td>
            <td class="text-left">
              {{ useServiceAgain.useServiceAgain4.value }}({{ useServiceAgain.useServiceAgain4.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left w-75">
              どちらかといえば思う
            </td>
            <td class="text-left">
              {{ useServiceAgain.useServiceAgain3.value }}({{ useServiceAgain.useServiceAgain3.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left w-75">
              どちらかといえば思わない
            </td>
            <td class="text-left">
              {{ useServiceAgain.useServiceAgain2.value }}({{ useServiceAgain.useServiceAgain2.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left w-75">
              思わない
            </td>
            <td class="text-left">
              {{ useServiceAgain.useServiceAgain1.value }}({{ useServiceAgain.useServiceAgain1.percent }}%)
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"
import { UseServiceAgain } from "../../stores/store_types"

export default defineComponent({
  name: "UseServiceAgainAnalyticsPart",
  props: {
    useServiceAgainProp: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const useServiceAgain = computed(() => props.useServiceAgainProp as UseServiceAgain)

    return {
      useServiceAgain
    }
  }
})
</script>
